/**
 * A stat tile's trend line: the history in a recessive ink, the current value
 * as a brand-coloured end dot. Decorative — the tile's number carries the
 * value — so it is hidden from assistive tech.
 */
export function Sparkline({
  values,
  width = 96,
  height = 28,
}: {
  values: readonly number[];
  width?: number;
  height?: number;
}) {
  if (values.length < 2) return null;
  const pad = 4; // room for the end dot and its ring
  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const x = (i: number) => pad + (i / (values.length - 1)) * (width - pad * 2);
  const y = (v: number) => pad + (1 - (v - min) / span) * (height - pad * 2);
  const d = values.map((v, i) => `${i ? "L" : "M"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join("");
  const last = values.length - 1;

  return (
    <svg aria-hidden="true" className="shrink-0 overflow-visible" height={height} width={width}>
      <path
        d={d}
        fill="none"
        stroke="var(--gq-text-muted)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.45}
        strokeWidth={1.5}
      />
      <circle
        cx={x(last)}
        cy={y(values[last]!)}
        fill="var(--gq-color-1)"
        r={3}
        stroke="var(--gq-surface-raised)"
        strokeWidth={2}
      />
    </svg>
  );
}
